import { z } from 'zod';

export const CampaignPropsSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  type: z.string().min(1, 'Type is required'),
  status: z.string().min(1, 'Status is required'),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
  owner_user_id: z.string().uuid().optional(),
});

export const EventPropsSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  type: z.string().min(1, 'Type is required'),
  status: z.string().min(1, 'Status is required'),
  start_datetime: z.string(),
  end_datetime: z.string().optional(),
  owner_user_id: z.string().uuid().optional(),
});

export const ListPropsSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  description: z.string().optional(),
  list_type: z.enum(['static', 'dynamic']).optional(),
});

export type CampaignProps = z.infer<typeof CampaignPropsSchema>;
export type EventProps = z.infer<typeof EventPropsSchema>;
export type ListProps = z.infer<typeof ListPropsSchema>;
